import React, { useEffect, useState } from "react";
import GolfLeagueMatches from "./GolfLeagueMatches";

const GolfInfoWrapper = ({
    sport,
    data,
    difference,
    matchType,
    loadCSS,
    baseUrl,
    setDataId,
    setDataType,
    setHead,
    isLive,
    dataClient,
    websiteBaseUrl,
    dataPath,
}) => {
    const [clientData, setClientData] = useState([]);

    useEffect(() => {
        if (!dataClient) return;
        const container = document.querySelector(".microservice-cont");
        const raw = container?.getAttribute("data-listingdata");
        if (!raw) return;

        try {
            const parsed = JSON.parse(raw)?.data?.data;
            setClientData(parsed || []);
        } catch (error) {
            console.error("Failed to parse client data:", error);
        }
    }, [dataClient]);


    const finalData = dataClient ? clientData : data;

    return (
        <>
            <GolfLeagueMatches
                data={finalData}
                difference={difference}
                matchType={matchType}
                loadCSS={loadCSS}
                sport={sport}
                baseUrl={baseUrl}
                setDataId={setDataId}
                setDataType={setDataType}
                setHead={setHead}
                type={isLive}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                dataClient={dataClient}
            />
        </>
    );
};

export default GolfInfoWrapper;
